<template>
    <div class="Section Credentials">
        <div class="Col">
            <img
                src="@/assets/svg/shield-check-fill.svg"
                alt="Staatliche Anerkennung - TaxiFusion erfüllt alle behördlichen Anforderungen"
                svg-inline
            />
            <h4>Staatlich Anerkannt</h4>
            <p>
                Wir erfüllen stets die aktuellen Voraussetzungen der wichtigsten Behörden der
                Taxibranche!
            </p>
        </div>
        <div class="Col">
            <img
                src="@/assets/svg/safe-2-fill.svg"
                alt="Datensicherheit - Sichere Datenspeicherung seit 2017"
                svg-inline
            />
            <h4>Aktuelle Sicherheit</h4>
            <p>
                Seit 2017 sind wir an Ihrer Seite und bieten Ihnen eine entsprechende Lösung zur
                Datenspeicherung für Ihr Fiskaltaxameter an.
            </p>
        </div>
        <div class="Col">
            <img
                src="@/assets/svg/cloud-fill.svg"
                alt="Cloud-Zugänglichkeit - TaxiFusion überall verwalten auf PC, Smartphone und Tablet"
                svg-inline
            />
            <h4>Überall zugreifen</h4>
            <p>
                Unsere webbasierte Software ermöglicht es Ihnen, Ihr Unternehmen von überall aus zu
                verwalten. Auf dem PC, Smartphone oder Tablet.
            </p>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.Credentials {
    @extend %sectionWrapper;
    flex-direction: row;
    display: flex;
    justify-content: space-between;
    gap: 30px;
    padding: 78px 40px 85px;

    @media (max-width: $breakpoint-tablet-portrait) {
        gap: 10px;
        flex-direction: column;
        padding: 60px 20px;
    }

    .Col {
        flex: 1;
        line-height: 40px;
        max-width: 1200px;
        margin: 0 auto;
        width: 100%;
        background-color: white;
        border-radius: 8px;
        padding: 30px;

        svg {
            width: 50px;
            height: 50px;
            margin-left: 10px;
            fill: var(--color-blue-dark);
        }

        h4 {
            padding-top: 20px;
            margin: 0;
            font-weight: 700;
            font-size: 26px;
            padding-bottom: 5px;
        }

        p {
            color: var(--color-text-black);
            font-size: 20px;
        }
    }
}
</style>
